






































import * as Util from '@/util.ts';
import * as Enums from '@/enums.ts';
import Vue from 'vue';

export default Vue.extend({
  props: {
    menuItem: {
      type: Object,
      required: true,
    },
  },
  mounted() {
    Util.eventBus.$on('menuTranslationUpdated', () => {
      this.$forceUpdate();
    });
  },
  methods: {
    showMenuInfoPage() {
      const menuItem: MenuItem = this.$props.menuItem;
      let viewCount: number = 0;
      let mutation = '';
      this.$store.commit('setCurrentMenuItem', menuItem);
      switch (this.$store.state.appMode) {
        case Enums.eAppModes.tableside:
          viewCount = this.$store.state.tablesideViewedCounts[menuItem.docId];
          mutation = 'setTablesideViewedCounts';
          break;
        case Enums.eAppModes.takeout:
          viewCount = this.$store.state.takeoutViewedCounts[menuItem.docId];
          mutation = 'setTakeoutViewedCounts';
          break;
        case Enums.eAppModes.delivery:
          viewCount = this.$store.state.deliveryViewedCounts[menuItem.docId];
          mutation = 'setDeliveryViewedCounts';
          break;
      }
      if (mutation) {
        this.$store.commit(mutation, {
          [menuItem.docId]: viewCount ? viewCount + 1 : 1,
        });
      }
      const menuPage: any = this.$parent.$parent;
      menuPage.showMenuInfoPageFunc();
    },
    getThumb(menuItem: MenuItem): string {
      const nameWithoutFileExtention = menuItem.images[0].name.split('.')[0];
      return menuItem.images[0].url.replace(nameWithoutFileExtention, `${nameWithoutFileExtention}_200x200`);
    },
    truncatedDescription(): string {
      const translatedDescription = Util.getTranslatedField(this.$props.menuItem, 'description');
      return translatedDescription.length <= 300 ? translatedDescription : translatedDescription.substring(0, 300) + '...';
    },
    translatedName(): string {
      return Util.getTranslatedField(this.$props.menuItem, 'name');
    },
  },
  computed: {
    showImages(): boolean {
      return this.$props.menuItem.images.length && this.showImagesAutomatically;
    },
    showImagesAutomatically(): boolean {
      return this.$store.state.showImagesAutomatically;
    },
    price(): string {
      return Util.formatCurrencyForMenuItem(this.$props.menuItem);
    },
  },
});
